import { render, staticRenderFns } from "./ImportFarmers.vue?vue&type=template&id=2721574a&"
import script from "./ImportFarmers.vue?vue&type=script&lang=js&"
export * from "./ImportFarmers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports